import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SportListComponent, SPORTS_LIST_SEGMENT_TAG } from './sport-list/sport-list.component'
import { EntityHubSmartComponent } from '../entity-hub/entity-hub-smart.component'
import { CollectionsResolver } from '../collections/collections.resolver'
import { EmptyTab } from '../events/components/event-detail/event-tabs/empty-tab/empty-tab.component'
import { SegmentTagV2 } from '../shared/analytics/models/segment-tag.model'

const SPORTS_SEGMENT_TAG: SegmentTagV2 = {
  autoPageCall: false,
  category: 'Sports',
  page_category: 'Sports'
}

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: SportListComponent,
        data: {
          shouldShowAdSkin: false,
          shouldShowEventTicker: true,
          /** For analytics directive */
          segment: SPORTS_LIST_SEGMENT_TAG
        }
      },
      {
        path: ':nodeId',
        component: EntityHubSmartComponent,
        resolve: { collection: CollectionsResolver },
        data: {
          shouldShowAdSkin: false,
          shouldShowEventTicker: true
        },
        children: [
          {
            path: '',
            component: EmptyTab,
            data: {
              segment: SPORTS_SEGMENT_TAG
            }
          },
          {
            path: ':tab',
            component: EmptyTab,
            data: {
              segment: SPORTS_SEGMENT_TAG
            }
          }
        ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class SportsRoutingModule {}
